import OOtgModalContainer from './o-otg-modal-container.vue';

export default OOtgModalContainer;